import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { isBoolean } from "lodash";
import { useState } from "react";
import { Confirm, useNotify } from "react-admin";
import {
  TenantRegistrationApiFactory,
  TenantRegistrationDto,
} from "../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";

interface Props {
  label: string;
  icon: JSX.Element;
  record?: TenantRegistrationDto;
  resource?: string;
  confirmTitle?: string;
  confirmContent?: string;
  onClick?: (event: React.MouseEvent) => void;
  onSuccess?: () => void;
  hidden?: boolean | ((record: TenantRegistrationDto) => boolean);
}

export const DeactivateTenantRegistrationMenuItem = ({
  record,
  hidden,
  label,
  icon,
  onClick,
  onSuccess,
  ...rest
}: Props) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const axios = useAxiosInstance();
  const notify = useNotify();

  if (!record?.id) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  const handleDeactivate = () => {
    if (!axios) {
      return;
    }

    setLoading(true);
    TenantRegistrationApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppTenantregistrationIdDeactivatePost(record.id!)
      .then(() => {
        notify(
          "resources.master-tenant-registrations.notifications.deactivateSuccess",
          {
            type: "success",
          }
        );

        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setLoading(false);
        setConfirmOpen(false);
      });
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setConfirmOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
      <Confirm
        isOpen={isConfirmOpen}
        loading={loading}
        title="Confirm to deactivate this customer"
        content={`Are you sure you want to deactivate the customer '${record.name}'?`}
        onConfirm={handleDeactivate}
        onClose={handleDialogClose}
      />
    </>
  );
};
